export const marketplaceConstants = {
  FETCH_ALL_MARKETPLACE_CARDS_REQUEST: "FETCH_ALL_MARKETPLACE_CARDS_REQUEST",
  FETCH_ALL_MARKETPLACE_CARDS_SUCCESS: "FETCH_ALL_MARKETPLACE_CARDS_SUCCESS",
  FETCH_ALL_MARKETPLACE_CARDS_FAILURE: "FETCH_ALL_MARKETPLACE_CARDS_FAILURE",

  CONFIGURE_MARKETPLACE_REQUEST: "CONFIGURE_MARKETPLACE_REQUEST",
  CONFIGURE_MARKETPLACE_SUCCESS: "CONFIGURE_MARKETPLACE_SUCCESS",
  CONFIGURE_MARKETPLACE_FAILURE: "CONFIGURE_MARKETPLACE_FAILURE",

  ACTIVE_CLOUD_STORAGE_REQUEST: "ACTIVE_CLOUD_STORAGE_REQUEST",
  ACTIVE_CLOUD_STORAGE_SUCCESS: "ACTIVE_CLOUD_STORAGE_SUCCESS",
  ACTIVE_CLOUD_STORAGE_FAILURE: "ACTIVE_CLOUD_STORAGE_FAILURE",

  FETCH_INFRA_BY_MARKETPLACE_ID_REQUEST: "FETCH_INFRA_BY_MARKETPLACE_ID_REQUEST",
  FETCH_INFRA_BY_MARKETPLACE_ID_SUCCESS: "FETCH_INFRA_BY_MARKETPLACE_ID_SUCCESS",
  FETCH_INFRA_BY_MARKETPLACE_ID_FAILURE: "FETCH_INFRA_BY_MARKETPLACE_ID_FAILURE",
};
